import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CategoryCarousel from "@/components/CategoryCarousel";
import BrandCarousel from "@/components/BrandCarousel";
import ProductCarousel from "@/components/ProductCarousel";
import Seo from "@/components/Seo";
import SchemaLd from "@/components/SchemaLd";
import HeroSlider from "@/components/HeroSlider";

const safeJson = (s) => { try { return JSON.parse(s); } catch { return undefined; } };

export default function StorefrontPage() {
  const [blocks, setBlocks] = useState([]);
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    api.get("/products/homepage-blocks").then((r) => setBlocks(r.data)).catch(() => setBlocks([]));
    api.get("/seo/page", { params: { type: "homepage", key: "home" } })
      .then((r) => setSeo(r.data.effective)).catch(() => setSeo(null));
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />

      <Seo
        title={seo?.seo_title || undefined}
        description={seo?.meta_description || undefined}
        image={seo?.og_image || undefined}
        noindex={seo?.seo_index === "noindex"} />
      <SchemaLd type="homepage" ekey="home" />

      <CategoryCarousel />

      <HeroSlider />

      {/* Catalog */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 w-full flex-1">
        <BrandCarousel />

        {/* Curated product blocks above footer */}
        {blocks.length > 0 && (
          <div data-testid="homepage-product-blocks">
            {blocks.map((b) => (
              <ProductCarousel key={b.key} title={b.title} products={b.products} testid={`homepage-product-${b.key}`} />
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
